import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import { suspense } from './utils';

const TimeEntriesPage = lazy(() => import('../features/timeEntries'));

export default function TimesheetRoutes() {
  return (
    <>
      <Route path="timesheets" element={suspense(<TimeEntriesPage />)} />
    </>
  );
}
